/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddPromotionCustomersRequest,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  GetPromotionCustomerCandidates200Response,
  GetPromotions200Response,
  UpdateAutomaticPromotionRequest,
  UpdateLocationComboRequest,
  UpsertPromotionRequest,
} from '../models/index';
import {
    AddPromotionCustomersRequestFromJSON,
    AddPromotionCustomersRequestToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    GetPromotionCustomerCandidates200ResponseFromJSON,
    GetPromotionCustomerCandidates200ResponseToJSON,
    GetPromotions200ResponseFromJSON,
    GetPromotions200ResponseToJSON,
    UpdateAutomaticPromotionRequestFromJSON,
    UpdateAutomaticPromotionRequestToJSON,
    UpdateLocationComboRequestFromJSON,
    UpdateLocationComboRequestToJSON,
    UpsertPromotionRequestFromJSON,
    UpsertPromotionRequestToJSON,
} from '../models/index';

export interface AddPromotionCustomersOperationRequest {
    promotionId: string;
    addPromotionCustomersRequest: AddPromotionCustomersRequest;
}

export interface DeletePromotionRequest {
    promotionId: string;
}

export interface DeletePromotionCustomersRequest {
    promotionId: string;
    addPromotionCustomersRequest: AddPromotionCustomersRequest;
}

export interface GetPromotionByIdRequest {
    promotionId: string;
}

export interface GetPromotionCustomerCandidatesRequest {
    promotionId: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetPromotionCustomersRequest {
    promotionId: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetPromotionsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface UpdateAutomaticPromotionOperationRequest {
    updateAutomaticPromotionRequest: UpdateAutomaticPromotionRequest;
}

export interface UpdatePromotionStatusRequest {
    promotionId: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface UpsertPromotionOperationRequest {
    upsertPromotionRequest: UpsertPromotionRequest;
}

/**
 * 
 */
export class PromotionsApi extends runtime.BaseAPI {

    /**
     */
    async addPromotionCustomersRaw(requestParameters: AddPromotionCustomersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling addPromotionCustomers().'
            );
        }

        if (requestParameters['addPromotionCustomersRequest'] == null) {
            throw new runtime.RequiredError(
                'addPromotionCustomersRequest',
                'Required parameter "addPromotionCustomersRequest" was null or undefined when calling addPromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddPromotionCustomersRequestToJSON(requestParameters['addPromotionCustomersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addPromotionCustomers(requestParameters: AddPromotionCustomersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addPromotionCustomersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletePromotionRaw(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling deletePromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePromotion(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletePromotionCustomersRaw(requestParameters: DeletePromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling deletePromotionCustomers().'
            );
        }

        if (requestParameters['addPromotionCustomersRequest'] == null) {
            throw new runtime.RequiredError(
                'addPromotionCustomersRequest',
                'Required parameter "addPromotionCustomersRequest" was null or undefined when calling deletePromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AddPromotionCustomersRequestToJSON(requestParameters['addPromotionCustomersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePromotionCustomers(requestParameters: DeletePromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionCustomersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getPromotionByIdRaw(requestParameters: GetPromotionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpsertPromotionRequest>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpsertPromotionRequestFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionById(requestParameters: GetPromotionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpsertPromotionRequest> {
        const response = await this.getPromotionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionCustomerCandidatesRaw(requestParameters: GetPromotionCustomerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotionCustomerCandidates200Response>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionCustomerCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}/customer/candidates`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotionCustomerCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionCustomerCandidates(requestParameters: GetPromotionCustomerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotionCustomerCandidates200Response> {
        const response = await this.getPromotionCustomerCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionCustomersRaw(requestParameters: GetPromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotionCustomerCandidates200Response>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotionCustomerCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionCustomers(requestParameters: GetPromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotionCustomerCandidates200Response> {
        const response = await this.getPromotionCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionsRaw(requestParameters: GetPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotions200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotions200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotions(requestParameters: GetPromotionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotions200Response> {
        const response = await this.getPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAutomaticPromotionRaw(requestParameters: UpdateAutomaticPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateAutomaticPromotionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAutomaticPromotionRequest',
                'Required parameter "updateAutomaticPromotionRequest" was null or undefined when calling updateAutomaticPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/automatic-promotion`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAutomaticPromotionRequestToJSON(requestParameters['updateAutomaticPromotionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAutomaticPromotion(requestParameters: UpdateAutomaticPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAutomaticPromotionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePromotionStatusRaw(requestParameters: UpdatePromotionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling updatePromotionStatus().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling updatePromotionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePromotionStatus(requestParameters: UpdatePromotionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePromotionStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertPromotionRaw(requestParameters: UpsertPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['upsertPromotionRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertPromotionRequest',
                'Required parameter "upsertPromotionRequest" was null or undefined when calling upsertPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertPromotionRequestToJSON(requestParameters['upsertPromotionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertPromotion(requestParameters: UpsertPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertPromotionRaw(requestParameters, initOverrides);
    }

}
